import { useState, useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Tabs from './Tabs';
import SearchBar from './SearchBar';
import ViewingChips from './ViewingChips';
import ResellerSearchResults from './ResellerSearchResults';
import { useAppViewContext } from '../lib/AppViewContext';
import styles from './ListChips.module.scss';

export default function ListChips() {
  const { selectedStatus, setSelectedStatus } = useAppViewContext();
  const history = useHistory();
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const searchQuery = urlParams.get('q');
  const [searchAction, setSearchAction] = useState<string>('');
  const [hasOwnerInfo, setHasOwnerInfo] = useState<boolean>(false);

  const handleQuerySubmitted = useCallback(
    (query: string) => {
      history.push({ search: `?q=${encodeURIComponent(query)}` });
    },
    [history],
  );

  const handleQueryCleared = useCallback(() => {
    history.push({ search: '' });
  }, [history]);

  return (
    <div>
      <div className={styles.main}>
        <header>
          <h1>Your chips</h1>
          <SearchBar
            onQuerySubmitted={handleQuerySubmitted}
            query={searchQuery}
            onQueryCleared={handleQueryCleared}
            searchAction={searchAction}
            hasOwnerInfo={hasOwnerInfo}
          />
        </header>
        <div className={styles.container}>
          {searchQuery ? (
            <ResellerSearchResults
              query={searchQuery}
              searchAction={searchAction}
              setSearchAction={setSearchAction}
              setHasOwnerInfo={setHasOwnerInfo}
              onQueryCleared={handleQueryCleared}
            />
          ) : (
            <div className={styles.list}>
              <Tabs selectedStatus={selectedStatus} onSelectionChanged={(newStatus) => setSelectedStatus(newStatus)} />
              <ViewingChips statusType={selectedStatus} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
